import { render, staticRenderFns } from "./BodyClientDetail.vue?vue&type=template&id=28294133&scoped=true"
import script from "./BodyClientDetail.vue?vue&type=script&lang=js"
export * from "./BodyClientDetail.vue?vue&type=script&lang=js"
import style0 from "./BodyClientDetail.vue?vue&type=style&index=0&id=28294133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28294133",
  null
  
)

export default component.exports